import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    dialogOpen: false,
    dialog2Open: false
}

const openDialog = (state) => {
    return {
        ...state,
        dialogOpen: true
    }
}

const openDialog2 = (state) => {
    return {
        ...state,
        dialog2Open: true
    }
}

const closeDialog = (state)=>{
    return {
        ...state,
        dialogOpen: false
    }
}

const closeDialog2 = (state)=>{
    return {
        ...state,
        dialog2Open: false
    }
}

export default reduce(initialState,{
    [actionTypes.ACTION_CONFIRM_DIALOG_OPEN]: openDialog,
    [actionTypes.ACTION_CONFIRM_DIALOG_CLOSE]: closeDialog,
    [actionTypes.ACTION_CONFIRM_DIALOG2_OPEN]: openDialog2,
    [actionTypes.ACTION_CONFIRM_DIALOG2_CLOSE]: closeDialog2,
});


// WEBPACK FOOTER //
// ./src/redux/actConfDialog/reducer.js